package ru.cleardocs.lkweb.firebase

/**
 * Firebase project configuration
 * Replace these values with your own Firebase project credentials
 */
val defaultFirebaseConfig = FirebaseConfig(
    apiKey = "AIzaSyCnXmtyg50fDXGwBWqzCbKeTDM6QbCmRgo",
    authDomain = "mlkit-d7731.firebaseapp.com",
    databaseUrl = "https://mlkit-d7731.firebaseio.com",
    projectId = "mlkit-d7731",
    appId = "1:630287825283:web:de7a345a3bb95ceeb21eb6",
    messagingSenderId = "630287825283",
    storageBucket = "mlkit-d7731.firebasestorage.app",
    measurementId = "G-1WDFFFB995"
)
